import { getCurrencySymbol } from 'components/modules/master/formatters';
import { roundTo } from 'utils/formatters/Precision';
import accounting from 'accounting';
import { isNil } from 'lodash';
import { NO_DATA } from 'utils/constants';
const defaultCurrency = DEFAULT_CURRENCY;

const formatMoney = (value, currency = defaultCurrency) => {
  if (isNil(value)) {
    return NO_DATA;
  }
  let amount = value && typeof value == 'number' ? roundTo(value, 2) : value;
  return accounting.formatMoney(amount, {
    format: {
      pos: '%s%v',
      neg: '-%s%v',
      zero: '%s%v',
    },
    symbol: getCurrencySymbol(currency) || '$',
  });
};

export default formatMoney;
